import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { FormCreator, FormFieldDef } from "@/components/shared/form-creator";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { CustomerContactFormValues as FormValues, customerContactSchema } from "../clients.entity";
import { Dispatch, SetStateAction, useEffect } from "react";
import { Customer } from "@/repositories/client.repository";

const schema = customerContactSchema;

interface EditClientContactProps {
  open: boolean;
  onOpenChange: Dispatch<SetStateAction<boolean>>;
  onSubmit: (values: FormValues) => void;
  clientToEdit?: Customer | null;
}

export function EditClientContact({ open, onOpenChange, onSubmit, clientToEdit }: EditClientContactProps) {
  const form = useForm<FormValues>({
    resolver: zodResolver(schema),
    defaultValues: { name: "", email: "", phone: "", designation: "" },
  });

  useEffect(() => {
    if (open) {
      if (clientToEdit) {
        form.reset({
          name: clientToEdit.contact?.name || "",
          email: clientToEdit.contact?.email || "",
          phone: clientToEdit.contact?.phone || "",
          designation: clientToEdit.contact?.designation || "",
        });
      }
    } else {
      form.reset();
    }
  }, [open, clientToEdit, form]);

  const fields: FormFieldDef[] = [
    { type: "text", name: "name", label: "Name", required: true },
    { type: "email", name: "email", label: "Email", required: true },
    { type: "text", name: "phone", label: "Phone" },
    { type: "text", name: "designation", label: "Designation" },
  ];
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit Client Contact</DialogTitle>
        </DialogHeader>
        <FormCreator form={form} onSubmit={onSubmit} formDefinition={fields} buttonText="Edit Client Contact " />
        <DialogFooter />
      </DialogContent>
    </Dialog>
  );
}
